export const ACTION_PROPERTY_MAP: Record<string, string> = {
  text: 'bulkSubActionsText',
  voice: 'bulkSubActionsVoice',
  email: 'bulkSubActionsEmail',
  push: 'bulkSubActionsPush',
  offer: 'bulkSubActionsOffer',
  performance: 'bulkSubActionsPerformance',
  coachingText: 'bulkSubActionsCoachingText',
  coachingVoice: 'bulkSubActionsCoachingVoice',
  coachingEmail: 'bulkSubActionsCoachingEmail',
  coachingPush: 'bulkSubActionsCoachingPush',
  paymentEmail: 'bulkSubActionsPaymentEmail',
  paymentPush: 'bulkSubActionsPaymentPush',
  reminderEmail: 'bulkSubActionsReminderEmail',
  reminderPush: 'bulkSubActionsReminderPush',
  alertRuleEmail: 'bulkSubActionsAlertRuleEmail',
};
